import { OrderPlanningActions } from "../../OrderPlanningActions";
import { PlanningTitle } from "../../PlanningTitle";
import { LoadMatchToolPanel } from "../LoadMatchToolPanel";
import { DataSource, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderPlanningOrders extends Layout {
    layoutLMTools: LoadMatchToolPanel;
    layoutOPAvailTools: OrderPlanningActions;
    layoutPlanningTitle: PlanningTitle;
    panelAvailFilters: Panel;
    panelAvailMoves: Panel;
    sourceAvailableMove: DataSource;
    tableAvailableMoves: Table;
    textboxDateRange: Textbox;
}
